import { render, staticRenderFns } from "./dispatchDialog.vue?vue&type=template&id=c3645d86&scoped=true"
import script from "./dispatchDialog.vue?vue&type=script&lang=js"
export * from "./dispatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3645d86",
  null
  
)

export default component.exports